let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("di3cH")).then(() => parcelRequire('dKIsW'));